import React from 'react';
import { connect } from 'react-redux';
import { getFeaturedMovies } from '../reducers';
import FullColumnLayout from "./FullColumnLayout";
import HomePageContent from "./HomePageContent";

class HomePage extends React.Component {
  render() {
    return <FullColumnLayout Content={HomePageContent} includeSearch={true} feat={this.props.hasFeaturedMovies} />
  }
}

const mapStateToProps = state => ({
  hasFeaturedMovies: getFeaturedMovies(state).length > 0,
});

export default connect(mapStateToProps)(HomePage);